/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { memo, useEffect, useState } from 'react';
import { Marker } from 'react-map-gl/mapbox';
import { useCuriosityManager } from '@/app/common/CuriosityManagerProvider.tsx';
import { Icon } from '@/app/common/icons/Icon';
import { SkiliftMarkerContainer } from './styled';
import type { SkiLift } from '../../../../../utils/api/filtersAPIResponseTypes';

type SkiliftMarkerProps = {
  skilift: SkiLift;
  selectedSkilift: SkiLift | undefined;
  setSelectedSkilift: React.Dispatch<SkiLift | undefined>;
};

const SkiliftMarker = memo(
  ({ setSelectedSkilift, skilift, selectedSkilift }: SkiliftMarkerProps) => {
    const { lat, lon, label } = skilift;
    const { curiosityClickEvents } = useCuriosityManager();
    const [hover, setHover] = useState(false);
    const [selected, setSelected] = useState(false);

    // TODO: Fix type
    const handleOnClick = (e: any) => {
      e.originalEvent.stopPropagation();
      setSelectedSkilift(undefined);
      setSelectedSkilift(skilift);
      setSelected(true);

      curiosityClickEvents.mapSkiLiftMarker();
    };

    const handleOnMouseEnter = () => {
      setHover(true);
    };

    const handleOnMouseLeave = () => {
      setHover(false);
    };

    useEffect(() => {
      if ((selectedSkilift === null || (selectedSkilift && selectedSkilift.label !== label)) && selected) {
        setSelected(false);
      }
    }, [selectedSkilift]);

    return (
      <Marker latitude={lat} longitude={lon} anchor="bottom" onClick={handleOnClick} style={{ zIndex: 1 }}>
        <SkiliftMarkerContainer
          hover={hover || selected}
          onMouseEnter={handleOnMouseEnter}
          onMouseLeave={handleOnMouseLeave}
        >
          <Icon category="Services" name="icon-cable-bar" size={12} color="iconOnDark" alt={label} />
        </SkiliftMarkerContainer>
      </Marker>
    );
  },
  (prevProps: SkiliftMarkerProps, nextProps: SkiliftMarkerProps) => {
    if (prevProps.selectedSkilift !== nextProps.selectedSkilift) return false;
    return true;
  }
);

SkiliftMarker.displayName = 'SkiliftMarker';

export default SkiliftMarker;
